import { CorporateToggleShape } from './types'
import Toggle from '@vtex/styleguide/lib/Toggle'
import React, { FC } from 'react'

const CorporateToggle: FC<CorporateToggleShape> = ({
  showCorporateToggle,
  showCorporateForm,
  corporateUpdateShow,
  intl,
}) => {
  const businessButtonMessage = showCorporateForm
    ? 'profile-form.exclude-business'
    : 'profile-form.include-business'
  return (
    <div>
      {showCorporateToggle && (
        <div className="flex mb7 mt5">
          <Toggle
            testId="toggleCorporate"
            id="toggleCorporate"
            label={intl.formatMessage({ id: businessButtonMessage })}
            checked={showCorporateForm}
            onChange={corporateUpdateShow}
          />
        </div>
      )}
    </div>
  )
}

export default CorporateToggle
